<template>
  <div class="mt-8 flex">
    <div class="w-1/3">
      <h2>Formatted Inputs</h2>
    </div>
    <div class="w-2/3">
      <m-form>
        <m-input
          id="input-dollar"
          v-model="form.dollar2"
          placeholder="Enter the dollar amount"
          state="disabled"
          :options="{
            numeral: true,
            numeralDecimalMark: '.',
            numeralDecimalScale: 2,
            numeralThousandsGroupStyle: 'thousand',
          }"
        />

        <m-input-dollar
          class="mt-2"
          id="input-dollar"
          v-model.number="form.dollar"
          :state="!$v.form.dollar.$invalid ? 'success' : 'error'"
          :options="{
            numeral: true,
            numeralDecimalMark: '.',
            numeralDecimalScale: 2,
            numeralThousandsGroupStyle: 'thousand',
          }"
        />
      </m-form>
      <pre>{{ form }}</pre>
    </div>
  </div>
</template>

<script>
import { required } from 'vuelidate/lib/validators';

export default {
  data: () => ({
    form: {
      text: '',
      dollar: 123456.23,
      dollar2: '',
    },
  }),
  validations: {
    form: {
      dollar: {
        required,
      },
    },
  },
};
</script>

<style></style>
